const search = () => {
	const searchButton = document.getElementById('search-button');
	const searchPopup = document.getElementById('search-popup');

	searchButton?.addEventListener('click', (event) => {
		event.stopPropagation();
		event.preventDefault();

		searchPopup?.classList.add('active');
		document.getElementById('search-input').focus();
	});

	searchPopup.addEventListener('click', (event) => {
		event.stopPropagation();
		event.preventDefault();

		event.target.classList.remove('active');
	});

	const submitSearchButton = document.getElementById('search-input-submit');

	submitSearchButton.addEventListener('click', (event) => {
		console.log('boooooo');
		const form = document.getElementById('search-popup-form');
		form.submit();
	});
};

export default search;
